export default "__VITE_ASSET__SbWWSgi3__"